import React from 'react';
import classnames, {TClassNameItem} from '@src/helpers/classnames';

export type TTextContainerWithOptionalClassNameProps = {
    tag?: keyof React.JSX.IntrinsicElements | React.ComponentType<{ className?: string }>,
    className?: string | TClassNameItem,
    children?: any
};

export default function TextContainerWithOptionalClassName(props: TTextContainerWithOptionalClassNameProps) {
    const {tag = React.Fragment, children} = props;

    const className = classnames(props.className);
    const Container = (className.length > 0 && tag === React.Fragment) ? 'span' : tag;

    // to prevent warning: Invalid prop `className` supplied to `React.Fragment`.
    // React.Fragment can only have `key` and `children` props.
    if (Container === React.Fragment) {
        return <Container>{children}</Container>;
    }

    return <Container className={className}>{children}</Container>;
}
